<template>
  <div class="CGOpenBorrow">
    <div>
      <div class="icon el-icon-circle-check-outline"></div>
      <div class="name">已经为您打开编号为：<span>{{boxId}}号箱格</span></div>
      <div class="tips">请尽快打开箱格，放好物品后并随手关门</div>
      <div class="tips mt20" v-if="isOverTips = true">{{time2}}秒后若箱门未关，系统将自动开始盘点</div>
    </div>
    <!-- <mqttws :topic="topic" :msg="msg" :isConnect="isConnect" :topic2="topic2" :msg2="msg2" :isSend="isSend" ref="mqttws" @getMessage="getMessage"></mqttws> -->

    <template v-if="isError == true">
      <div class="tipDio">
        <div class="name">未在规定时间内打开箱格</div>
        <div class="name">请重新操作</div>
        <div class="tips"><b>{{time}}s</b></div>
        <div class="backbtn"><el-button @click="backUp">返回</el-button></div>
      </div>
      <div class="bgDiv"></div>
    </template>
    <currtime :isShowInfo="false"></currtime>
  </div>
</template>

<script>
import currtime from '../../../../../assets/currTime'
import mqttws from '../../../../../assets/mqttws'
import { checkData } from '../../../../../../static/js/utils/util.js'
import { borrowApi } from "../../../../../../static/js/api.js"
import { text2Audio,getMp3 } from '../../../../../../static/js/utils/utility.js'
import * as config from '../../../../../../static/js/config.js';
import again2Mp3 from '../../../../../../static/mp3/again2.mp3'
import openTip1 from '../../../../../../static/mp3/openTip1.mp3'
import openTip3 from '../../../../../../static/mp3/openTip3.mp3'
import {websocketsend} from  '../../../../../../static/js/utils/socket.js'
export default {
  name: 'CGOpenBorrow',
  data () {
    return {
      boxId:'',

      topic:'/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol/response',
      msg:'',
      isConnect:true,//是否默认订阅

      topic2:'/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol',
      msg2:'',
      isSend:true,
      
      time2:120,
      timeStatus2:'',
      isOverTips:false,

      overtime:30,//超时
      overtimeStatus:'',//超时状态

      sendMsg:'',
    }
  },
  mounted(){

  },
  created(){
    var that = this;
    this.boxId = this.$route.query.boxId
    var boxId =this.$route.query.boxId

    this.sendMsg = 'd704'+boxId
    websocketsend(this.sendMsg);
    // if(boxId <= 9){
    //   boxId = '0'+boxId
    // }
    var msg = 'a5551505160101010000000101d6060001'+boxId;
    var num = checkData(msg)
    msg = msg+num
    that.msg2 = msg
    that.overTime(that.overtime)
  },
  components:{
    mqttws,
    currtime
  },
  methods:{
    openTip2Fun(){
      var url = openTip3
      var audio = new Audio(url);
      audio.src = url;
      audio.play();
    },
    //接收socket
    getSkMsg(res){
      var that = this;
      this.isNetWork = false
      if(res){
        if(res.fun_code == 'd704'){
          if(res.cells[0].lock_status == '2'){
            // that.errorOpen = 0
            //text2Audio('已经为您打开'+that.boxId+'号箱格，请尽快打开箱格，放好物品后并随手关门')
            var url = openTip1
            var audio = new Audio(url);
            audio.src = url;
            audio.play();
            audio.addEventListener('ended', function () {
              getMp3(that.boxId,() =>{
                that.openTip2Fun()
              })
            }, false);
            clearTimeout(that.overopenStatus)
            that.getSecond2(that.time2)
            that.isOverTips = true
          }else if(res.cells[0].lock_status == '1'){
              //开门失败
              // text2Audio('未在规定时间内打开箱格，请重新操作')
              that.isError = true
              var url = '../../../../../static/mp3/again2.mp3'
              var audio = new Audio(url);
              audio.src = url;
              audio.play();
              that.getSecond(that.time)
          }
        }else if(res.fun_code == 'E501'){
          if(res.cells[0].lock_status == '1'){
            //关门
            clearTimeout(that.timeStatus2)
            that.$router.push({
              path:'/toolCabinet/CGiveBack/CGInventory',
              query:{
                boxId:that.boxId
              }
            })
          }
        }
      }
    },
    //接收mqtt信息
    getMessage(data){
      var that = this;
      if(data){
        var str = data.substring(2,data.length-2);//截取字符串的第二到倒数第二的数据
        var num = checkData(str)
        var bbc = data.substr(data.length-2)
        // var lastTwo = str.substring(str.length-6,str.length-4)
        var id = str.substring(str.length-4,str.length)
        var type = str.substring(26,30)
        // if(lastTwo == 55 && num == bbc){
        if(num == bbc && type == 'd606'){
          //是否开门
          that.overtime=30
          var lastTwo = str.substring(str.length-2,str.length)
          if(lastTwo == 55){
            var topic = '/'+ config.clientPort +'/report/'+ config.serverPort +'/environment/protocol'
            that.$refs.mqttws.onConnect(topic)
            // text2Audio('已经为您打开'+that.boxId+'号箱格，请尽快打开箱格，放好物品后并随手关门')
          }else{

          }
        }else if(num == bbc && type == 'df0f'){
          //是否真正开门
          clearTimeout(that.overtimeStatus)
          var lastTwo = str.substring(str.length-2,str.length)
          if(lastTwo == 55){
            // var topic = '/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol'
            // var msg = 'A5551505160101010000000101D6040001'+that.boxId
            // var num = checkData(msg)
            // msg = msg+num
            // this.$refs.mqttws.send(topic,msg)
            // this.$refs.mqttws.disconnect()
            // that.$router.push({
            //   path:'/CGiveBack/CGInventory',
            //   query:{
            //     boxId:that.boxId
            //   }
            // })
            that.getSecond2(that.time2)
            that.isOverTips = true
          }else{
            that.isError = true
            // text2Audio('未在规定时间内打开箱格，请重新操作')
            var url = again2Mp3
            var audio = new Audio(url);
            audio.src = url;
            audio.play();
            that.getSecond(that.time)
          }
        }else if(num == bbc && type == 'df10'){
          //是否关门
          var lastTwo = str.substring(str.length-2,str.length)
          if(lastTwo == 'aa'){
            clearTimeout(this.timeStatus2)
            // this.$refs.mqttws.disconnect()
            that.$router.push({
              path:'/toolCabinet/CGiveBack/CGInventory',
              query:{
                boxId:that.boxId
              }
            })
          }else{

          }
        }
      }
    },
    //倒计时
    getSecond2(wait){
      var that = this;
      var _wait = wait;
      if(wait == 0) {
        wait = _wait;
        clearTimeout(this.timeStatus2)
        // this.$refs.mqttws.disconnect()
        that.$message.error('系统开始自动盘点，盘点结果可能不准确~ ')
        setTimeout(function(){
          that.$router.push({
            path:'/toolCabinet/CGiveBack/CGInventory',
            query:{
              boxId:that.boxId
            }
          })
        },3000)
      } else {
        this.time2=wait
        wait--;
        that.timeStatus2 = setTimeout(function() {
          that.getSecond2(wait);
        },1000);
      }
    },
    //倒计时
    getSecond(wait){
      var that = this;
      var _wait = wait;
      if(wait == 0) {
        clearTimeout(that.timeStatus)
        that.isError = false;
        that.backUp()
      } else {
        this.time=wait
        wait--;
        that.timeStatus = setTimeout(function() {
          that.getSecond(wait);
        },1000);
      }
    },
    //返回
    backUp(){
      
      // this.$refs.mqttws.disconnect()
      this.$router.push({
        path:'/toolCabinet/CLogin'
      })
    },
    //超时
    overTime(wait){
      var that = this;
      var _wait = wait;
      if(wait == 0) {
        wait = _wait;
        clearTimeout(that.overtimeStatus)
        that.$router.go(0)
      } else {
        this.overtime=wait
        wait--;
        that.overtimeStatus = setTimeout(function() {
          that.overTime(wait);
        },1000);
      }
    }
  },
  watch :{
    "$store.state.wsMsg":function(newVal){
      this.getSkMsg(newVal)
    }
  },
}
</script>

<style lang="less">
.CGOpenBorrow{
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  // background: url('../../../../../../static/images/bg.jpg') center no-repeat;
  // background-size: cover;
  .icon{
    color: #4babfe;
    font-size: 2rem;
  }
  .name{
    font-size: 0.5rem;
    margin: 0.8rem 0 0.27rem;
    span{color:#fff;}
  }
  .tips{
    font-size: 0.36rem;
    color: #e2dfdf;
  }
  .tipDio{
    width: 50%;
    position: fixed;
    top: 10%;
    left:50%;
    margin-left: -25%;
    background: #fff;
    color: #333;
    z-index: 100;
    border-radius: 0.1rem;
    .tips{
      font-size: 0.3rem;
    }
    .backbtn{
      text-align: right;
      margin: 0.2rem;
      .el-button{
        height: 0.94rem;
        width: 2.54rem;
        padding: 0;
        margin: 0 1.2rem;
        font-size: 0.4rem;
        color: #fff;
        font-weight: bold;
        border: none;
        border-radius: 0.12rem;
        line-height:0.94rem;
        background: linear-gradient(#4aaafe, #0769be);
      }
    }
  }
  .bgDiv{
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    z-index: 99;
    left: 0;
    right: 0;
    top: 0;
    bottom:0;
  }
  .currTime{
    position: absolute;
    right: 0.2rem;
    top: 0.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CToolCabinet/page/CEmployee/CGiveBack/CGOpenBorrow.vue